import { jsx as l } from "react/jsx-runtime";
import { f as p } from "../../../index-CxTlXOY2.js";
import { TableBodyCell as u } from "./TableBodyCell.js";
import { useTable as b } from "../hooks/useTable.js";
import { propagateTestid as g } from "../../../utils/helpers.js";
const C = ({
  hiddenHeader: n,
  scope: r = "row",
  tableId: c,
  ...t
}) => {
  const o = b(), d = o == null ? void 0 : o.api.getSortedRowModel().rows;
  return d != null && d.length ? /* @__PURE__ */ l("tbody", { ...t, children: d.map((i) => {
    var a;
    return /* @__PURE__ */ l(
      "tr",
      {
        "data-testid": (a = t == null ? void 0 : t["data-testid"]) == null ? void 0 : a.replace("tbody", "row"),
        children: i.getVisibleCells().map((e, f) => {
          var m;
          return /* @__PURE__ */ l(
            u,
            {
              "data-testid": g(
                (m = t["data-testid"]) == null ? void 0 : m.replace("tbody", "cell"),
                `row_${i.id}__col_${e.column.id}`
              ),
              cellApi: e,
              hiddenHeader: n,
              index: f,
              scope: r,
              tableId: c,
              children: p(e.column.columnDef.cell, e.getContext())
            },
            e.id
          );
        })
      },
      i.id
    );
  }) }) : null;
};
export {
  C as TableBody
};
